import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Info from "./components/Info";
import LaCucina from "./components/LaCucina";
import LaPiccola from "./components/LaPiccola";
import LaStanzetta from "./components/LaStanzetta";
import Eventi from "./components/Eventi";
import LaGrande from "./components/LaGrande";
import Cursor from "./components/Cursor";
import IlGiardino from "./components/IlGiardino";

export default function App() {
  return (
    <>
      <Router>
        <Cursor />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/info" element={<Info />} />
          <Route path="/lacucina" element={<LaCucina />} />
          <Route path="/lapiccola" element={<LaPiccola />} />
          <Route path="/lastanzetta" element={<LaStanzetta />} />
          <Route path="/lagrande" element={<LaGrande />} />
          <Route path="/eventi" element={<Eventi />} />
          <Route path="/ilgiardino" element={<IlGiardino />} />
        </Routes>
      </Router>
    </>
  );
}
